<template>
	<div></div>
	<v-container fluid>
		<v-row class="mb-3">
			<v-col cols="7" md="6" class="d-flex align-center">
				<div class="d-flex align-center">
					<v-icon class="me-5" style="color: #ff7e87" size="40">mdi-target-account</v-icon>
					<p class="text-lg-h5 font-weight-600">
						{{ $t('role_list') }} ({{ this.totalRoles }})
					</p>
				</div>
			</v-col>
		</v-row>

		<v-card rounded="xl">
			<v-card-text>
				<div class="dashboard">
					<!-- Emit created -->
					<!-- @added = getALlList -->
					<data-table :headers="isSmallScreen ? smallScreenHeaders : headers" :items="items"
						@openAgentEditor="openEditUserDialog" @openActiveInactiveDialog="openActiveInactiveDialog">
					</data-table>
				</div>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import RoleListDataTable from '@/components/RoleListDataTable.vue'
import ownerService from '@/services/API/ownerService'

export default {
	name: 'HomeView',
	components: {
		'data-table': RoleListDataTable,
	},
	data: () => ({
		items: [],
		totalRoles: null,
		headers: [
			{
				text: 'Created Date',
				value: 'createdAt',
				width: '25%',
			},
			{
				text: 'Role and permission',
				value: 'description',
				width: '20%',
			},
			{
				text: 'Status',
				value: 'status',
				width: '10%',
			},
		],
	}),
	async created() {
		await ownerService.listRoles().then((response) => {
			this.items = response.data.data
		})

		this.totalRoles = this.items.length
	},
	computed: {
		isSmallScreen() {
			return this.$vuetify.display.smAndDown
		},
		smallScreenHeaders() {
			return this.headers.filter((item) =>
				['Agent name', 'Skills', 'Status'].includes(item.text)
			)
		},
	},
	methods: {},
}
</script>
<style scoped>
.box-shadow {
	box-shadow: 0px 0px 16px 0px rgba(131, 133, 143, 0.1) !important;
}
</style>
